import { useState } from "react";
import { HeartHandshake } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CONSULTING } from "@/constants/testIds";
import { toast } from "sonner";

export function ConsultingRequestButton({ employeeId, defaultContext, label = "Solicitar consultoría con un profesional de RH", onSubmitted }) {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState(defaultContext || "");

  const handleSubmit = async () => {
    try {
      const { data } = await api.post("/consulting-requests", { context, employee_id: employeeId || null });
      toast.success(data.message);
      setOpen(false);
      onSubmitted?.();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (v) setContext(defaultContext || ""); }}>
      <DialogTrigger asChild>
        <Button data-testid={CONSULTING.requestButton} variant="outline" className="rounded-full border-petroleum/30">
          <HeartHandshake className="w-4 h-4 mr-2" /> {label}
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-bone">
        <DialogHeader><DialogTitle>Solicitar consultoría con un profesional de RH</DialogTitle></DialogHeader>
        <p className="text-sm text-charcoal/60">
          Describe brevemente tu situación. Un profesional de RH (humano, no una IA) revisará tu caso y te contactará
          directamente por correo o teléfono — ahí te dirá el costo y el tiempo estimado antes de cobrarte nada.
          Enviar esta solicitud no tiene costo y no reemplaza la asesoría de un abogado laboral.
        </p>
        <Textarea data-testid={CONSULTING.contextInput} value={context} onChange={(e) => setContext(e.target.value)} className="bg-white min-h-28" placeholder="Ej. Quiero orientación antes de decidir sobre la baja de un empleado..." />
        <Button data-testid={CONSULTING.submitButton} disabled={!context.trim()} onClick={handleSubmit} className="w-full bg-petroleum rounded-full">Enviar solicitud</Button>
      </DialogContent>
    </Dialog>
  );
}
